import React from 'react';

const AcademicHistory = () => {
  const education = [
    {
      degree: "MSc in Information Technology Management",
      institution: "Hong Kong Baptist University",
      period: "2012 – 2014",
      note: "Bridge between technology strategy and business management"
    },
    {
      degree: "BSc in Computer Systems (Computer Science)",
      institution: "Hong Kong Baptist University",
      period: "2003 – 2006",
      note: "Foundation in software engineering, algorithms, and systems architecture"
    }
  ];

  return (
    <div>
      {education.map((edu, index) => (
        <div key={index} className="education-card">
          <div className="education-header">
            <div>
              <div className="education-degree">{edu.degree}</div>
              <div className="education-school">{edu.institution}</div>
            </div>
            <span className="education-period">{edu.period}</span>
          </div>
          <div className="education-note">{edu.note}</div>
        </div>
      ))}
    </div>
  );
};

export default AcademicHistory;
